// https://blog.logrocket.com/how-to-use-axios-vue-js/
import { initializeApp } from "firebase/app";
import { getAnalytics, setUserProperties } from "firebase/analytics";
import { useFirebase } from "@/composables/useFirebase";

export default {
  install: () => {
    console.info("Initializing Firebase analytics");

    if (!import.meta.env.VITE_FIREBASE_API_KEY) {
      console.warn("Firebase analytics disabled, missing API key");
      return;
    }

    const app = initializeApp({
      apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
      authDomain: "wijsneus-widget.firebaseapp.com",
      projectId: "wijsneus-widget",
      storageBucket: "wijsneus-widget.firebasestorage.app",
      messagingSenderId: "322826975453",
      appId: "1:322826975453:web:6f3964b563feffd5cf0334",
      measurementId: "G-3Y9ESJ43DJ",
    });

    const { analytics } = useFirebase();

    analytics.value = getAnalytics(app);

    const { assistantId, settingsId } = useGlobalConfig();

    setUserProperties(analytics.value, {
      assistant_id: assistantId.value,
      settings_id: settingsId.value,
    });
  },
};
